const QueryForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.orderDate', // 订单日期范围
            key:'order_date',
            type:'dateRange',
            // allowClear:false,
            width:'260px',
        },
        {
            name:'order.orderSource', // 来源
            key:'source',
            type:'select',
            width:'260px',
            allowClear:true,
            multiple:true,
            options:[]
        },
        {
            name:'order.orderStatus', // 订单状态
            key:'order_status',
            type:'select',   
            allowClear:true,
            multiple:true,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation'
                },
                {
                    value:0,
                    label:'order.partialPay'
                },
                {
                    value:1,
                    label:'order.pay'
                },
                {
                    value:2,
                    label:'order.refund'
                },
                {
                    value:4,
                    label:'order.partialRefund'
                },
                // {
                //     value:-1,
                //     label:'order.finalPayment'
                // },
                {
                    value:6,
                    label:'order.canceled'
                },
            ]
        },
        {
            name:'order.deliverStatus', // 发货状态
            key:'courier_status',
            type:'select',
            allowClear:true,
            multiple:true,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.unship'
                },
                {
                    value:1,
                    label:'order.plan'
                },
                {
                    value:2,
                    label:'order.partialShip'
                },
                {
                    value:3,
                    label:'order.shiped'
                },
                {
                    value:4,
                    label:'order.signedFor'
                },
                {
                    value:5,
                    label:'order.canceled'
                },
                {
                    value:8,
                    label:'order.return'
                },
                {
                    value:9,
                    label:'order.exchange'
                },
            ]
        },
        {
            name:'order.orderChannelType', // 客户类型
            key:'order_channel_type',
            type:'select',
            allowClear:true,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:2,
                    label:'order.ECommerceVendor',
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
    ]
}

// 已出库整车筛选
const QueryForm2 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.orderDate', // 订单日期范围
            key:'order_date',
            type:'dateRange',
            width:'260px',
        },
        {
            name:'dataBoard.planShipDate', // 出库计划日期范围 
            key:'ship_date',
            type:'dateRange',
            width:'260px',
        },
        {
            name:'dataBoard.realShipDate', // 出库实际日期范围 
            key:'real_ship_date',
            type:'dateRange',
            width:'260px',
        },
        {
            name:'order.orderSource', // 来源
            key:'source',
            type:'select',
            width:'260px',
            allowClear:true,
            multiple:true,
            options:[]
        },
        {
            name:'order.orderStatus', // 订单状态
            key:'order_status',
            type:'select',   
            allowClear:true,
            multiple:true,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation'
                },
                {
                    value:1,
                    label:'order.pay'
                },
                {
                    value:2,
                    label:'order.refund'
                },
                {
                    value:4,
                    label:'order.partialRefund'
                },
                {
                    value:-1,
                    label:'order.finalPayment'
                },
                {
                    value:6,
                    label:'order.canceled'
                },
            ]
        },
        // {
        //     name:'order.courierStatus', // 发货状态
        //     key:'courier_status',
        //     type:'select',
        //     allowClear:true,
        //     multiple:true,
        //     width:'260px',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             value:0,
        //             label:'order.unship'
        //         },
        //         {
        //             value:1,
        //             label:'order.plan'
        //         },
        //         {
        //             value:2,
        //             label:'order.partialShip'
        //         },
        //         {
        //             value:3,
        //             label:'order.shiped'
        //         },
        //         {
        //             value:4,
        //             label:'order.signedFor'
        //         },
        //         {
        //             value:5,
        //             label:'order.canceled'
        //         },
        //         {
        //             value:8,
        //             label:'order.return'
        //         },
        //         {
        //             value:9,
        //             label:'order.exchange'
        //         },
        //     ]
        // },
        {
            name:'order.orderChannelType', // 客户类型
            key:'order_channel_type',
            type:'select',
            allowClear:true,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:2,
                    label:'order.ECommerceVendor',
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            name:'order.warehouse', // 仓库
            key:'warehouse',
            type:'select',
            allowClear:true,
            width:'260px',
            options:[]
        },
    ]
}

// 及时交付率
const QueryForm3 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.orderDate', // 订单日期范围 
            key:'order_date',
            type:'dateRange',
            width:'260px',
        },
        {
            name:'dataBoard.realShipDate', // 实际发货日期范围 
            key:'ship_date',
            type:'dateRange',
            width:'260px',
        },
        {
            name:'order.warehouse', // 仓库
            key:'warehouse',
            type:'select',
            width:'260px',
            allowClear:true,
            options:[]
        },
        // {
        //     name:'dataBoard.category', // 产品类型
        //     key:'category',
        //     type:'select',
        //     width:'340px',
        //     allowClear:true,
        //     options:[]
        // },
    ]
}

QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
})

QueryForm2.formField.forEach(item=>{
    QueryForm2.formData[item.key] = ''
})

QueryForm3.formField.forEach(item=>{
    QueryForm3.formData[item.key] = ''
})


export {
    QueryForm,
    QueryForm2,
    QueryForm3,
}